export const VOICEMAILS_LOADED = "voicemail/load"
export const VOICEMAIL_UPDATED = "voicemail/updated"